import {
  GET_ARTISTS_FAIL,
  GET_ARTISTS_SUCCESS,
  CLEAR_ARTISTS,
} from './actionTypes';

const INIT_STATE = {
  artists: [],
  totalArtist: 0,
  error: {},
  loading: false,
};

const events = (state = INIT_STATE, action) => {
  switch (action?.type) {
    case GET_ARTISTS_SUCCESS:
      return {
        ...state,
        loading: false,
        artists: [
          ...(state.artists || []),
          ...(action?.payload?.data?.artistList || []),
        ],
        totalArtist: action?.payload?.data?.filter_count,
      };

    case GET_ARTISTS_FAIL:
      return {
        ...state,
        loading: false,
        error: action?.payload,
      };

    case CLEAR_ARTISTS:
      return {
        ...state,
        artists: [],
      };

    default:
      return state;
  }
};

export default events;
